import Toast from '@/components/toast';
import Notify from '@/components/notify';
import Input from '@/components/input';
import TyConfirm from '@/components/ty-confirm';
import { Button, ButtonGroup } from '@/components/button';
import Layer from '@/components/layer';

import Vue from 'vue';
const components = [Input, Button, ButtonGroup, Layer, TyConfirm];

const install = function(Vue, opts = {}) {
  components.forEach((component) => {
    Vue.component(component.name, component);
  });
  Vue.prototype.$UToast = Toast.install;
  Vue.prototype.$UNotify = Notify.install;
  Vue.prototype.$TyConfirm = TyConfirm.install;
};

install(Vue);
